import api from './api';

export interface TopResult {
  type: 'artist' | 'album';
  item: SearchArtist | SearchAlbum;
  similarity: number;
}

export interface SearchSuggestion {
  correctedQuery: string;
  originalQuery: string;
}

export interface SearchPlaylist {
  id: string;
  servicePlaylistId: string;
  name: string;
  description: string | null;
  trackCount: number;
  duration: number;
  imageUrl: string | null;
  isPublic: boolean;
  owner: string;
  source: string;
  sourceLabel?: string;
  isPreview?: boolean;
}

export interface UnifiedSearchResult {
  query: string;
  results: {
    artists: SearchArtist[];
    albums: SearchAlbum[];
    tracks: SearchTrack[];
    playlists?: SearchPlaylist[];
  };
  topResult: TopResult | null;
  suggestion: SearchSuggestion | null;
  sources: string[];
  primaryService: string;
}

export interface SearchArtist {
  id: string;
  serviceArtistId: string;
  name: string;
  imageUrl: string | null;
  albumCount: number;
  source: string;
  sourceLabel: string;
  isPreview: boolean;
}

export interface SearchAlbum {
  id: string;
  serviceAlbumId: string;
  title: string;
  artistName: string;
  artistId: string;
  coverUrl: string | null;
  coverUrlSmall: string | null;
  coverUrlThumbnail: string | null;
  releaseDate: string | null;
  trackCount: number;
  duration: number;
  hires: boolean;
  maxBitDepth: number | null;
  maxSampleRate: number | null;
  genre: string | null;
  label: string | null;
  source: string;
  sourceLabel: string;
  isPreview: boolean;
  qualityLabel: string;
}

export interface SearchTrack {
  id: string;
  serviceTrackId: string;
  title: string;
  albumTitle: string;
  artistName: string;
  duration: number;
  trackNumber: number;
  hires: boolean;
  maxBitDepth: number | null;
  maxSampleRate: number | null;
  coverUrl: string | null;
  source: string;
  sourceLabel: string;
  isPreview: boolean;
  qualityLabel: string;
}

export const searchService = {
  unified: (query: string, limit = 10): Promise<UnifiedSearchResult> =>
    api.get(`/api/search/unified?q=${encodeURIComponent(query)}&limit=${limit}`),
};
